import React from 'react';

import { DASH } from 'Components/budget_change_requests/changeRequestFormat';

import { calendarDate, figure, FOOTER_CELL } from './commitmentFormat';

const percent = (value) => `${Number(value ?? 0).toFixed(2)}%`;

/**
 * Each payment's share of its bucket's committing total, summed and only then
 * rounded to the cent. Summing the rows' already-rounded values drifts a cent:
 * three thirds of 10,000 add up to 9,999.99. Falls back to that sum when the
 * committing totals are absent.
 */
const scheduleTotal = (milestones, committingTotal) => {
    if (!committingTotal) {
        return milestones.reduce((sum, milestone) => sum + Number(milestone.value || 0), 0);
    }

    const total = milestones.reduce((sum, milestone) => sum + (Number(committingTotal[milestone.bucket] ?? 0) * Number(milestone.percentage || 0)) / 100, 0);

    return Math.round(total * 100) / 100;
};

/** The draft payment schedule being approved, each payment valued against its bucket's committing total. */
export default function PaymentMilestonesTable({ milestones, committingTotal }) {
    const totalPercentage = milestones.reduce((sum, milestone) => sum + Number(milestone.percentage || 0), 0);
    const totalValue = scheduleTotal(milestones, committingTotal);

    return (
        <div>
            <div className="bc-eyebrow">{$t('Payment milestones')}</div>
            {milestones.length === 0 ? (
                <div className="bc-sub tw-text-[13px]">{$t('No milestones set')}</div>
            ) : (
                <div className="inbud-table_wrapper bc-table-wrapper">
                    <table className="inbud-table bc-table">
                        <thead>
                            <tr>
                                <th>{$t('Date')}</th>
                                <th>{$t('Description')}</th>
                                <th className="bc-num">%</th>
                                <th className="bc-num">{$t('Value')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {milestones.map((milestone, index) => (
                                <tr key={index}>
                                    <td className="tw-whitespace-nowrap">{calendarDate(milestone.date)}</td>
                                    <td className="tw-break-words">{milestone.description || DASH}</td>
                                    <td className="bc-num">{Number(milestone.percentage).toFixed(2)}</td>
                                    <td className="bc-num">{figure(milestone.value)}</td>
                                </tr>
                            ))}
                            <tr className="tw-font-semibold">
                                <td colSpan={2} className={FOOTER_CELL}>
                                    {$t('Total')}
                                </td>
                                <td className={`bc-num ${FOOTER_CELL}`}>{percent(totalPercentage)}</td>
                                <td className={`bc-num ${FOOTER_CELL}`}>{figure(totalValue)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
